import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./ErrorPages.scss";

function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="error-page">
      <div className="text-center">
        <h3 className="page-title">Not authorized</h3>
        <h1 className="number-code">
          <span>4</span>
          <span>0</span>
          <span>1</span>
        </h1>
        <h2 className="page-subtitle">
          We are sorry, but you don&apos;t have permission to access this page.
          You can try to
        </h2>
        <div className="page-actions">
          <Button size="large" onClick={() => navigate("/login")}>
            Login
          </Button>
          <span className="divider">or</span>
          <Button size="large" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
